module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frontpage"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.sites), function(site, i) {
    return _c('card', {
      attrs: {
        "project": site,
        "project_id": i
      }
    })
  })), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frontpage-content"
  }, [_c('h1', [_vm._v("Hi, I'm Doug")]), _vm._v(" "), _c('h2', [_vm._v("Full Stack Web Developer")]), _vm._v(" "), _c('ul', {
    staticClass: "frontpage-content__links"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://linkedin.com/in/dougblackjr2"
    }
  }, [_vm._v("Linkedin")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.twitter.com/dougblackjr"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://dougblackjr.com#contact"
    }
  }, [_vm._v("Email")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://earn.com/dougblackjr/"
    }
  }, [_vm._v("Ask a Question")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.dropbox.com/s/y56z9es0sl41xpf/resume_doug_black.pdf?dl=0"
    }
  }, [_vm._v("Resume")])])]), _vm._v(" "), _c('p', [_vm._v("I make machines serve their human masters, typically with web and mobile applications! Skilled in: PHP, ExpressionEngine, Laravel, Wordpress, Vue.js, Javascript, Ionic/Angular, Salesforce Development (Apex) and various others. If you have a problem, I can solve it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "http://dougblackjr.com/#contact"
    }
  }, [_vm._v("Contact me to get started!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afd9e3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 48
// module chunks = 0